import { render, staticRenderFns } from "./QiaohuPopup.vue?vue&type=template&id=71de9bfb&scoped=true"
import script from "./QiaohuPopup.vue?vue&type=script&lang=js"
export * from "./QiaohuPopup.vue?vue&type=script&lang=js"
import style0 from "./QiaohuPopup.vue?vue&type=style&index=0&id=71de9bfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de9bfb",
  null
  
)

export default component.exports